import {
  selectActiveProjectId,
  selectActiveProjectName,
  uploadPolygonsFiles,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import { getUploadDataAnalyticParams } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import type { FC } from 'react'
import { useEffect } from 'react'

import type { AddingFilesModalContainerPropsType as PropsType } from './types'

const AddingFilesPolygonModalContainer: FC<PropsType> = ({ files = null }) => {
  const dispatch = useAppDispatch()
  const sendSpaEvent = useSpa()
  const activeProjectId = useAppSelector(selectActiveProjectId)
  const activeProjectName = useAppSelector(selectActiveProjectName)

  useEffect(() => {
    if (files) {
      sendSpaEvent(
        'import from file_end',
        getUploadDataAnalyticParams(activeProjectName, 'Polygons'),
      )
      dispatch(uploadPolygonsFiles({ projectId: activeProjectId, files }))
    }
  }, [files])

  // Пока модалка не готова, грузим как есть, без настроек
  return null
}

export { AddingFilesPolygonModalContainer }
